import type { StateStorage } from 'zustand/middleware';

/**
 * zustand `persist` storage backed by localStorage, standing in for the mobile
 * app's AsyncStorage. Async on purpose: the stores were written against an
 * async driver and gate first paint on `_hasHydrated`, so keeping the same
 * shape means the store files stay identical to mobile's apart from this import.
 *
 * Reads/writes are wrapped because localStorage throws (not returns null) in
 * Safari private mode and when a browser is set to block site data.
 */
export const webStorage: StateStorage = {
  getItem: async (name) => {
    try {
      return globalThis.localStorage?.getItem(name) ?? null;
    } catch {
      return null;
    }
  },
  setItem: async (name, value) => {
    try {
      globalThis.localStorage?.setItem(name, value);
    } catch {
      /* quota or blocked storage — preferences just don't survive a reload */
    }
  },
  removeItem: async (name) => {
    try {
      globalThis.localStorage?.removeItem(name);
    } catch {
      /* ignore */
    }
  },
};
